enum EAccountActivateFileType {
  DOCUMENT_PASSPORT = 'passport',
  DOCUMENT_SNILS = 'snils',
  DOCUMENT_INDIVIDUAL_ENTREPRENEUR = 'document_individual_entrepreneur',
  DOCUMENT_COMPANY = 'document_company',
  NONE = 'none',
}

export default EAccountActivateFileType;
